import { render } from "./CreateRegional.vue?vue&type=template&id=ee69c002&scoped=true"
import script from "./CreateRegional.vue?vue&type=script&lang=js"
export * from "./CreateRegional.vue?vue&type=script&lang=js"

import "./CreateRegional.vue?vue&type=style&index=0&id=ee69c002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee69c002"]])

export default __exports__